<template>
  <v-app :style="'height:100%;background-image:url(' + bg + ');background-size:cover;'">

    <v-dialog
      v-model="welcome_dialog"
      scrollable
    >
      <v-card>
        <v-card-title>ประกาศ
          <v-spacer></v-spacer>
            <v-btn @click="welcome_dialog=false" text><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text align="left" class="text-body-1 mt-4">
          <span style="white-space: pre-line;">
          {{station_annooucement_welcome}}
          </span>
        </v-card-text>
      </v-card>
    </v-dialog>

      <div style="height:45%;position: relative;">
          <v-img :src="logo" width="50%" style="margin: auto;position:absolute; bottom:0;left:25%;" class="mb-6" />
      </div>
      <div style="height:15%;">
        <div class="text-h5">{{ station_name }}</div>
        <div class="text-h5">{{ $t('Station_Welcome') }}</div>
      </div>
      <div style="height:35%;">
        <div v-if="!is_stationmember">
          <v-btn  @click="register" color="#00E4FF" class="pa-6 text-h5">
            {{ $t('Register') }}
          </v-btn>
          <div class="mt-4 text-h7">{{last_stationregister_text}}</div>
        </div>
        <div class="text-h6" v-else>
          <div class="mt-4">
          <v-btn  @click="$router.push({name:'AppointmentManage_Station',params:{station_code:$route.params.station_code}})" color="#00E4FF" class="pa-6 text-h5">
            นัดหมายของฉัน
          </v-btn>
          </div>
          <div class="mt-4">
          <v-btn :disabled="!line_reservation_enable" @click="newappointment()" color="#00E4FF" class="pa-6 text-h5">
            จองคิวล่วงหน้า
          </v-btn>
          </div>
        </div>
      </div>
  </v-app>
</template>


<style>
html {
    height: 100%;
}
body {
    height: 100%;
}
#app {
    height: 100%;
}
</style>

<script>

import axios from 'axios';
import config from '@/../config.js'
import App from '@/models/instance/App'
import Member from '@/models/instance/Member'
import AppointmentSelection from '@/models/instance/AppointmentSelection.js'

export default {
  data () {
    return {
      bg : ""
      ,logo : require('@/assets/9manat-line-logo-01.png')
      ,station_name : ""
      ,station_annooucement_welcome : ""
      ,last_stationregister : null
      ,is_stationmember : false
      ,line_reservation_enable : true
      ,welcome_dialog : false
    }
  },
  computed: {
    last_stationregister_text(){
      if(this.last_stationregister != null){
        var date = new Date(this.last_stationregister)
        date.setHours(date.getHours()+7)
        var today = new Date()
        today.setHours(today.getHours()+7)
        return this.$t('last_stationregister') + " : " + 
          (date.toISOString().substring(0,10)==today.toISOString().substring(0,10) ? 
            date.toISOString().substring(11,20) : date.toISOString().substring(0,10)
          )
      }
      return ""
    }
  },
  mounted : function () {
    this.$store.getters.getStationShortDetail(this.$route.params.station_code)
    .then(station_shortdetail=>{
        this.station_name = station_shortdetail.station_name
        
        this.line_reservation_enable = station_shortdetail.line_reservation_enable == 'true'
        this.station_annooucement_welcome = station_shortdetail.station_annooucement_welcome

        if(this.station_annooucement_welcome.length > 0){
          this.welcome_dialog = true
        }

        this.bg = App.getAppConfigBackgroud()
        this.logo = App.getAppConfigLogo()

        var que = this.$store.commit('addLoading')
        axios
        .post(config.api.url.line.station.get_stationmemberstatus
          ,{ station_code:this.$route.params.station_code}
          ,{ headers: Member.getTokenHeader()})
        .then(response => {
            this.last_stationregister = response.data.last_stationregister
            this.is_stationmember = response.data.is_stationmember
            this.$store.commit('finishLoading',que)           
        })

    })
  },
  methods : {
    newappointment : function() {
      AppointmentSelection.setStationCode(this.$route.params.station_code);
      this.$router.push({name:'AppointmentNewStep',params:{step_id:'1'}})
    },
    register : function() {
      this.$router.push({
          name:'RegisterForm'
          ,params:{station_code:this.$route.params.station_code
          ,callback:{
            name:"Success",params: { 
              success_text_1:  this.$t('success_register_1')
              ,success_text_2:  this.$t('success_register_2')
            }
          }
        }
      })
    }
  },
}
</script>